import React from 'react';
import {
    AreaChart,
    Area,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    ReferenceLine
} from 'recharts';

export default function StateStimulusChart({ data, stateName }) {
    if (!data || data.length === 0) return null;

    const formatYAxis = (value) => `$${(value / 1e9).toFixed(0)}B`;

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div className="custom-tooltip" style={{ background: 'rgba(10, 15, 30, 0.9)', border: '1px solid rgba(255,255,255,0.2)', padding: '10px', borderRadius: '8px' }}>
                    <p className="label" style={{ color: '#94a3b8', margin: 0, fontSize: '0.8rem' }}>{label}</p>
                    <p className="value" style={{ color: '#10b981', fontWeight: 'bold', margin: '4px 0' }}>
                        Net Stimulus: ${(payload[0].value / 1e9).toFixed(2)}B
                    </p>
                    <div style={{ fontSize: '0.75rem', color: '#cbd5e1', borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: '4px', marginTop: '4px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '20px' }}>
                            <span>Total "Get":</span>
                            <span>${(payload[0].payload.get / 1e9).toFixed(2)}B</span>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '20px' }}>
                            <span>Total "Pay":</span>
                            <span>${(payload[0].payload.pay / 1e9).toFixed(2)}B</span>
                        </div>
                    </div>
                </div>
            );
        }
        return null;
    };

    return (
        <div className="chart-container state-impact-chart">
            <h3>Net State Stimulus: {stateName}</h3>
            <ResponsiveContainer width="100%" height={300}>
                <AreaChart data={data}>
                    <defs>
                        <linearGradient id="colorStimulus" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#10b981" stopOpacity={0.3} />
                            <stop offset="95%" stopColor="#10b981" stopOpacity={0} />
                        </linearGradient>
                    </defs>
                    <CartesianGrid strokeDasharray="3 3" stroke="var(--bg-tertiary)" vertical={false} />
                    <XAxis
                        dataKey="year"
                        stroke="var(--text-secondary)"
                        style={{ fontSize: '11px', fontWeight: 600 }}
                        tickLine={false}
                        axisLine={false}
                    />
                    <YAxis
                        stroke="var(--text-secondary)"
                        style={{ fontSize: '11px', fontWeight: 600 }}
                        tickLine={false}
                        axisLine={false}
                        tickFormatter={formatYAxis}
                        label={{ value: 'Net Impact', angle: -90, position: 'insideLeft', fill: 'var(--text-muted)', fontSize: '11px' }}
                    />
                    <Tooltip content={<CustomTooltip />} />
                    <ReferenceLine y={0} stroke="rgba(255,255,255,0.2)" />
                    <Area
                        type="monotone"
                        dataKey="netStimulus"
                        stroke="#10b981"
                        strokeWidth={3}
                        fillOpacity={1}
                        fill="url(#colorStimulus)"
                        animationDuration={1500}
                    />
                </AreaChart>
            </ResponsiveContainer>
        </div>
    );
}
